module.exports = __webpack_public_path__ + "6636d10d.png";